
export enum FilterType {
    Market = 10,
    Properties = 20,
    NewDwelling = 30,
    Commercial = 40,
    WeeklyTrendReport = 50
}

export interface FilterOverview {
    filterType: FilterType;
    id: number;
    name: string;
    hasAreaFilter: boolean; //geo and areas
    hasUnitFilter: boolean;
    createdTimestamp: Date;
    numberOfUnits: number;
} 

export interface SortOption {
    name: string;
    prop: string;
    desc: boolean;
    type?: "number" | "text" | "date" | "date-string" | "identifier" | "regexp";
    useStringMask?:boolean;
}

export interface SearchDropDownItem {
    key: string;
    subtext?: string;
    isSelected?: boolean;
    data?: any;
}

export interface FilterId {
    id: number;
}